module.exports = __webpack_public_path__ + "static/media/santa_rita.83592431.png";